import { connect } from 'react-redux';
import Sidebar from './sidebar';
import { preserveFitToWidth, multiplePanelsOpen } from '../../../shared/actions/sidebarUtils';
import { closeAllPanels, updateSidebarWidth } from '../../../shared/actions/sidebar';

const mapStateToProps = state => ({
  panelGroups: state.sidebar.panelGroups,
  isOpen: state.sidebar.isOpen,
  isModal: multiplePanelsOpen(state),
});

const mapDispatchToProps = dispatch => ({
  preserveFitToWidth: () => dispatch(preserveFitToWidth()),
  onEscKeyDown: () => dispatch(closeAllPanels()),
  updateSidebarWidth: () => dispatch(updateSidebarWidth()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
